import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  loadingContent: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing[4],
  },
  // Same dim the DLS applies to a disabled button, without HTML `disabled`.
  loading: {
    opacity: 0.4,
  },
  // Visually hidden live region for screen readers.
  loadingStatus: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    opacity: 0,
  },
});
